
import { defineComponent, computed, watch, ref } from 'vue';
import { MutationTypes } from '@/store/mutations';
import ErrorMessage from '@/components/UI/ErrorMessage.vue';
import { useStore } from '@/store';
import Checkbox from 'vue-material-checkbox';

export default defineComponent({
    name: 'ContactDetailsForm',
    components: { ErrorMessage, Checkbox },
    setup () {
        const store = useStore();
        const userEmail = ref(null);

        const email = computed({
            get: () => store.state.email,
            set: value => store.commit(MutationTypes.SetEmail, value)
        });
        const rememberDetails = computed({
            get: () => store.state.rememberDetails,
            set: value => store.commit(MutationTypes.SetRememberDetails, !!value)
        });
        const isEmailError = computed(() => store.state.isEmailError);
        const needFocus = computed(() => store.state.needFocusEmail);
        watch(needFocus, value => {
            if (value) {
                (userEmail as HTMLInputElement).focus();
                store.commit(MutationTypes.SetNeedFocusEmail, false);
            }
        });
        return { email, rememberDetails, isEmailError };
    }
});
